<template>
  <smallModal @escape="$emit('close')">
    <div v-if="ccc != null">
      <div class="buttons-flex-end">
        <button @click="captchaImg" class="btn">
          <b-icon-arrow-repeat id="captcha-add-company"></b-icon-arrow-repeat>
        </button>
      </div>
      <div class="imgDiv">
        <img :src="ccc" class="capImg">
      </div>
      <label :for="captchaName">{{ lang['EnterCaptcha'] }}</label>
      <b-form-input v-model="captcha" :state="capState" autofocus :name="captchaName" />
    </div>
    <div class="passwordCheck">
      <label for="phone">{{ lang['Password'] }}</label>
      <b-form-input type="password" id="password-input" :state="statePass" v-model="password" />
      <span v-if="statePass" @click="showPass" :class="isPassVisible ? 'icon-eye' : 'icon-eye-blocked'"></span>
    </div>
    <hr>
    <div class="buttons">
      <button class="btn btn-secondary" @click="cansel">{{ lang['Сancel'] }}</button>
      <button :disabled="$store.disableButton" class="btn btn-success" @click="save">{{ lang['Save'] }}</button>
    </div>
  </smallModal>
</template>

<script>
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { rotate } from '../js/rotateBtn'; // Імпортуємо функцію rotate для обертання елемента на 180 градусів з анімацією
import { guid } from '../js/guid'; // Імпортуємо функцію guid для створення унікальних ідентифікаторів
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна
import { regAPi } from '@/API.js';
import { store } from "@/store.js" // Глобальне сховище даних
const apiList = new regAPi();
export default {
  components: {
    smallModal
  },
  data() {
    return {
      password: '',
      isPassVisible: false,
      captcha: '',
      guidNow: '',
      ccc: null,
      captchaName: 'captcha_' + this.getRandNum(999, 99999)
    }
  },
  created() {
    this.captchaImg()
  },
  mounted() {
    keyevent.$off('enter');
    keyevent.$on('enter', () =>
      this.save()
    )
  },
  methods: {
    getRandNum(min, max) {
      return Math.random() * (max - min) + min;
    },
    captchaImg() {
      try {
        // создаем гуид (файл guid.js) который скидываем для капичи состарта, потом, если юзер нажал сохранить, то скидываем текущий гуид на сервак для сравнения
        const a = guid();
        const c = apiList.captchaUID(a);
        this.ccc = c;
        this.guidNow = a;
        // крутилка для кнопки
        rotate('#captcha-add-company');
        this.captcha = ''
      } catch (err) {
        console.log(err);
      }
    },
    cansel() {
      this.$emit('close');
    },
    // клик по кнопке, закрываем окно и перебрасываем пароль в родителя и данные по капче
    save() {
      if (this.statePass) {
        store.disableButton = true;
        this.$emit('checkPass', { account_password: this.password, captcha: this.captcha, captcha_guid: this.guidNow });
      } else {
        window.say.messageError(this.lang['MinPassLength']);
      }
    },
    showPass() {
      this.isPassVisible = !this.isPassVisible
      const input = document.getElementById('password-input');
      if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text');
      } else {
        input.setAttribute('type', 'password');
      }
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang;
    },
    statePass() {
      return this.password.length >= 1 ? true : false;
    },
    capState() {
      return this.captcha.length == 4 ? true : false;
    }
  }
}
</script>

<style scoped>
.form-control.is-valid,
.form-control.is-valid:focus {
  border-color: #00c279;
}

.form-control.is-valid {
  border-color: #00c279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

.form-control.is-invalid,
.form-control.is-invalid:focus {
  border-color: #ff3548;
}

.form-control.is-invalid {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
}

.button {
  display: flex;
  justify-content: space-between;
}

.btn-secondary,
.btn-success {
  width: 49%;
}

.imgDiv {
  text-align: center;
  height: 100px;
}

.capImg {
  height: 100px;
}

#captcha-add-company {
  height: 2rem;
  width: 2rem;
}

.buttons-flex-end {
  display: flex;
  justify-content: flex-end;
}

.icon-eye,
.icon-eye-blocked {
  position: absolute;
  right: 40px;
  top: 58.5%;
}
</style>